var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.loading)?_c('GrayBoxLoader',{attrs:{"cardRow":""}}):_c('ul',{staticClass:"stat-cards"},_vm._l((_vm.cards),function(card){return _c('StatCard',{key:`stat-card-${card.id}`,attrs:{"data":card}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }